module.exports = __webpack_public_path__ + "files/e250cfa8762ffa9906ff441a2d919e9a.png";